import { call, put } from "redux-saga/effects";
import { updateDetailsPrompt } from "../../api/profileApi";
import * as actions from "../actions";

export default function* updateDetailsStoreDate() {
  try {
    yield call(updateDetailsPrompt);
  } catch (error) {
    yield put(actions.addError("updateDetailsStoreDate", error));
  }
}
